import Insight from "../insightClass";
import React from "react";
import {
  UKCfDAR7_2,
  UKCfDAR7_2_CN,
  UKCFDAR7_2Preview,
  UKCFDAR7_2PreviewGroup,
} from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
import UKCFDAR7 from "./UKCFDAR7";
export const insight081 = new Insight(
  "09 December 2025",
  {
    pageTitle:
      "CfD Evolution: Is AR7 a New Chapter in Britain's Offshore Wind?",
    metaDescription:
      "WeBridge Insights, CfD Evolution: Is AR7 a New Chapter in Britain's Offshore Wind?",
    keyWords:
      "European Offshore Wind Market development, CfD Evolution: Is AR7 a New Chapter in Britain's Offshore Wind?",
  },
  {
    src: UKCFDAR7_2Preview,
    alt: "pdf preview",
  },
  "CfD Evolution: Is AR7 a New Chapter in Britain's Offshore Wind?",
  "",
  `The UK's next offshore wind auction, Allocation Round 7 (AR7), will be a true test of how fast the industry can grow, and how well the supply chain can keep up. With higher strike prices, 20-year CfDs, and new incentives like the Clean Industry Bonus, AR7 could be a vital step toward the UK's 2030 goals. But beyond policy success, the challenge lies in delivery: Turbines, foundations, cables, vessels, and ports are all running close to capacity. The coming years will test the limits of Europe's offshore wind supply chain, and its ability to scale sustainably.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>CfD Evolution: Is AR7 a New Chapter in Britain's Offshore Wind?</h1>
    <h2></h2>
    <p className="article-date">09 December 2025</p>
    <br />
    <p>
      The UK's next offshore wind auction, Allocation Round 7 (AR7), will be a
      true test of how fast the industry can grow, and how well the supply chain
      can keep up.
    </p>
    <p>
      With higher strike prices, 20-year CfDs, and new incentives like the Clean
      Industry Bonus, AR7 could be a vital step toward the UK's 2030 goals.
    </p>
    <p>But beyond policy success, the challenge lies in delivery:</p>
    <p>
      Turbines, foundations, cables, vessels, and ports are all running close to
      capacity. The coming years will test the limits of Europe's offshore wind
      supply chain, and its ability to scale sustainably.
    </p>
    <p>
      At WeBridge, we help connect UK developers with trusted global suppliers,
      bridging market, technical, and cultural gaps to turn CfD wins into
      real-world delivery.
    </p>

    <UKCFDAR7
      pdfUrl={UKCfDAR7_2}
      pdfUrlCN={UKCfDAR7_2_CN}
      pdfName={[
        "UK CfD Evolution",
        "Is AR7 a New Chapter in Britain's Offshore Wind?",
      ]}
      pdfNameCN={[
        "英国差价合约机制（CfD）的演变AR7 是否将开启英国海上风电的新篇章",
      ]}
      pdfPreview={UKCFDAR7_2PreviewGroup}
    />

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
